import { createReducer } from '@reduxjs/toolkit'
import * as metalQuotationAction from '../actions/metalQuotation'
import { APIData, APIStatus } from '../axiosConfiguration'
import { MetalQuotationResponse } from '../type/metalQuotation'

type MetalQuotationState = {
  info: APIData<MetalQuotationResponse>
}

const initialState: MetalQuotationState = {
  info: { status: APIStatus.IDLE },
}

export default createReducer(initialState, (builder) => {
  builder
    .addCase(metalQuotationAction.getMetalQuotation.fulfilled, (state, action) => {
      state.info.status = APIStatus.FULFILLED
      state.info.data = action.payload
    })
    .addCase(metalQuotationAction.getMetalQuotation.rejected, (state, action) => {
      state.info.status = APIStatus.REJECTED
      state.info.error = action.payload
    })
    .addCase(metalQuotationAction.getMetalQuotation.pending, (state) => {
      state.info.status = APIStatus.PENDING
    })
})
